<template>
  <div class="contai_h">
    <div class="cont_cont">
      <el-breadcrumb separator="/" class="cons">
        <el-breadcrumb-item>仓库管理</el-breadcrumb-item>
        <el-breadcrumb-item><a href="/wares">物品出库</a></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="cont_tabs">
      <el-tabs type="border-card" @tab-click="ces">
        <!-- 建当出库 -->
        <el-tab-pane label="建当物品出库">
          <el-table :data="items" border style="width: 100%">
            <el-table-column prop="deta" label="建档日期" width="180"> </el-table-column>
            <el-table-column prop="ticketnumber" label="票号" width="180">
            </el-table-column>
            <el-table-column prop="name" label="姓名" width="120"> </el-table-column>

            <el-table-column prop="telnumber" label="电话" width="150"> </el-table-column>
            <el-table-column prop="objname" label="物品名称" width="150">
            </el-table-column>
            <el-table-column prop="weight" label="重量/g" width="120"> </el-table-column>
            <el-table-column prop="startdate" label="开始日期" width="120">
            </el-table-column>
            <el-table-column prop="enddate" label="终止日期" width="120">
            </el-table-column>
            <el-table-column prop="reviewdate" label="复核日期" width="150">
            </el-table-column>
            <el-table-column prop="cardnumber" label="证件号码" width="200">
            </el-table-column>
            <el-table-column prop="address" label="地址" width="280"> </el-table-column>
            <el-table-column prop="agent" label="经办人" width="150"> </el-table-column>
            <el-table-column prop="review" label="复核" width="150"> </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-popover placement="left" width="200" trigger="click">
                  <el-select v-model="value" clearable placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-button type="primary" round size="mini" @click="chus(scope.row._id)"
                    >确定出库</el-button
                  >
                  <el-button type="text" size="small" slot="reference"
                    >出库操作</el-button
                  >
                </el-popover>
              </template>
            </el-table-column>
          </el-table>

          <!-- <el-dialog title="出库确认" :visible.sync="dialogTableVisible">
      </el-dialog> -->
        </el-tab-pane>

        <!-- 收回出库 -->
        <el-tab-pane label="收回物品出库">
          <el-table :data="shitems" border style="width: 100%">
            <el-table-column prop="input_pnum" label="票号" width="130">
            </el-table-column>
            <el-table-column prop="deta" label="建档日期" width="180"> </el-table-column>
            <el-table-column prop="input_names" label="姓名" width="100">
            </el-table-column>
            <el-table-column prop="input_wus" label="物品名称" width="150">
            </el-table-column>
            <el-table-column prop="tabs_ins" label="重量/g" width="100">
            </el-table-column>
            <el-table-column prop="tabs_inps" label="数量" width="80"> </el-table-column>
            <el-table-column prop="tabs_is" label="回收价格" width="90">
            </el-table-column>
            <el-table-column prop="reviewdate" label="复核日期" width="130">
            </el-table-column>
            <el-table-column prop="inputzf" label="支付备注" width="180">
            </el-table-column>
            <el-table-column prop="input_idcards" label="证件号码" width="200">
            </el-table-column>
            <el-table-column prop="input_adds" label="地址" width="280">
            </el-table-column>
            <el-table-column prop="input_tels" label="电话" width="150">
            </el-table-column>
            <el-table-column prop="agent" label="经办人" width="120"> </el-table-column>
            <el-table-column prop="review" label="复核" width="120"> </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-popover placement="left" width="200" trigger="click">
                  <el-select v-model="value" clearable placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-button type="primary" round size="mini" @click="shus(scope.row._id)"
                    >确定出库</el-button
                  >
                  <el-button type="text" size="small" slot="reference"
                    >出库操作</el-button
                  >
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
export default {
  name: "wares",
  data() {
    return {
      ACCESS_TOKEN: "", //ACCESS_TOKEN
      items: [], //建当的数据
      shitems: [], //收回出库
      token: "", //token
      name: "", //当前登录的用户名

      options: [
        {
          value: "赎回出库",
          label: "赎回出库",
        },
        {
          value: "饰台",
          label: "饰台",
        },
        {
          value: "其他",
          label: "其他",
        },
      ],
      // dialogTableVisible: false, //默认不显示弹窗
      value: "",
    };
  },
  methods: {
    // 点击确定出库
    chus(e) {
      let id = e;

      this.axios
        .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("add_data").doc("' +
            id +
            '").update({data:{warehcname:"' +
            this.name +
            '",warehstat:"' +
            this.value +
            '"}})',
        })
        .then((rec) => {
          if (rec.data.errcode == 0) {
            this.$notify({
              title: "出库成功",
              message: "该物品已成功出库",
              type: "success",
            });
          } else {
            this.$notify.error({
              title: "出库失败",
              message: "请检查token是否过期",
            });
          }
        });

      setTimeout(() => {
        this.$router.go(0);
      }, 1500);
    },

    //收回确认
    shus(e) {
      let id = e;
      this.axios
        .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("take_back").doc("' +
            id +
            '").update({data:{warehcname:"' +
            this.name +
            '",warehstat:"' +
            this.value +
            '"}})',
        })
        .then((rec) => {
          if (rec.data.errcode == 0) {
            this.$notify({
              title: "出库成功",
              message: "该物品已成功出库",
              type: "success",
            });
          } else {
            this.$notify.error({
              title: "出库失败",
              message: "请检查token是否过期",
            });
          }
        });

      setTimeout(() => {
        this.$router.go(0);
      }, 1500);
    },

    //点击切换tabs
    ces(e) {
      if (e.index == 1) {
        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              'db.collection("take_back").where({whether:true,wareh:true,warehcname:""}).limit(1000).get()',
          })
          .then((ach) => {
            ach.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.shitems = ach.data.data;
          });
      }
    },
    //默认请求建当的可出库的物品
    warehout() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("add_data").where({state:"在当",whether:true,wareh:true,warehcname:""}).limit(1000).get()',
        })
        .then((acg) => {
          if(acg.data.errcode !== 0 ){
            return  this.$notify.error({
              title: '错误提示',
              message: '密钥过期啦，请刷新页面'
            });
          }
          acg.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.items = acg.data.data;
        });
    },

  },
  created() {
    // this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN"); //获取到this.ACCESS_TOKEN
       //获取到this.ACCESS_TOKEN
     this.getTokens()

    //获取当前登录的用户数据
    this.getUserToken()
  },
  mounted() {
    setTimeout(()=>{
      this.warehout();

    this.name = this.userData.username
    },800)
    
  },
};
</script>
<style scoped>
.cont_cont {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.cons {
  margin: 0 20px;
}
.cont_tabs {
  margin: 20px 0;
}
</style>
